// extracted by mini-css-extract-plugin
export default {"rotatingText":"RotatingText_rotatingText__5pTew","fadeIn":"RotatingText_fadeIn__+T+5r","fadeOut":"RotatingText_fadeOut__v1f9l"};